<div class="confirm-dialog-backdrop" *ngIf="isOpen" (click)="onBackdropClick()"></div>

<div class="confirm-dialog" *ngIf="isOpen" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
  <div class="confirm-dialog__header">
    <h3 id="confirm-dialog-title" class="confirm-dialog__title">{{ title }}</h3>
  </div>
  <div class="confirm-dialog__body">
    <p class="confirm-dialog__message" *ngIf="message">{{ message }}</p>
    <ng-content></ng-content>
  </div>
  <div class="confirm-dialog__actions">
    <button type="button" class="btn btn-secondary" data-testid="confirm-dialog-cancelar" (click)="onCancel()">{{ cancelLabel }}</button>
    <button type="button" class="btn btn-primary" data-testid="confirm-dialog-confirmar" (click)="onConfirm()">{{ confirmLabel }}</button>
  </div>
</div>